import { combineReducers } from 'redux';

import data from './data/reducer';

export default combineReducers({
  data,
});
